/**
 * Quote block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is lazy-loaded
 * only when the block is present and motion is allowed.
 */

import './index.scss';

const quoteBlocks = document.querySelectorAll('.quote');

if (quoteBlocks.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		quoteBlocks.forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.quote[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const heading = block.querySelector('.quote__heading');
					const content = block.querySelector('.quote__content');

					const els = [heading, content].filter(Boolean);

					if (els.length) {
						gsap.to(els, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							stagger: 0.12,
							scrollTrigger: {
								trigger: block,
								start: 'top 85%',
								once: true,
							},
						});
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
